import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Popover, OverlayTrigger, Button } from "react-bootstrap";
import { clickifyPhoneNumber, capitalizeFirstLetter } from "Utils/Utils";
import { useMediaQuery } from 'react-responsive';
import Menu from "Components/Menu/Menu";
import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import useSession from "Utils/Hooks/useSession";
import useMode from "Utils/Hooks/useMode";
import { PRODUCTTYPES } from "Utils/Constants";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";

import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import arrowback from "Assets/Icons/arrow-back.svg";
import help from "Assets/Icons/help.svg";
import profile from "Assets/Icons/profile.svg";
import "./Header.scss";


const Header = ({ back=true, isEnrollment=false }) => {
  const mode = useMode();
  const { session, invalidateSession } = useSession();
  const isVIPPreferred = session?.patronProductType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? 'VIP Preferred' : 'VIP Online';
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;
  const { vipAccount } = useVipAccountCache();
  const vipApi = useVipApiFetcher();
  const isMobile = useMediaQuery({
    query: '(max-width: 767.98px)'
  });
  let history = useHistory();
  const userName = `${capitalizeFirstLetter(vipAccount?.firstName)} ${capitalizeFirstLetter(vipAccount?.lastName)}`;
  const logout = async () => {
    await NotifyLogout();
  };
  const helpMessage = <div className="text-center">
    <div>Need support? Call CAMS</div>
    <div className="phone">{clickifyPhoneNumber('1-800-500-1973')}</div>
  </div>
  const helpPopover = <Popover>
                    <Popover.Content>
                      {helpMessage}
                    </Popover.Content>
                  </Popover>;

  const profileMessaage = <div className="text-center">
    <div>Welcome, {userName}!</div>
    <button className="logout click-menu-logout" onClick={logout}>Close {productType}</button>
  </div>
  const profilePopover = <Popover>
                    <Popover.Content>
                      {profileMessaage}
                    </Popover.Content>
                  </Popover>;
  const logo = <div onClick={() => {history.push('dashboard')}}><img className="vip-preferred" src={logoSrc} alt={productType} /></div>;
  const backButton = <Button variant="Link" className="back-button click-back-button" onClick={() => history.goBack()}><img alt="Go back" src={arrowback} /></Button>;
  const helpButton = <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={helpPopover}>
                      <Button className="float-right" variant="Link"><img className="top-menu-icon" alt="Help" src={help} /></Button>
                    </OverlayTrigger>;
  const profileButton = <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={profilePopover}>
                      <Button className="float-right" variant="Link"><img className="top-menu-icon" alt="Profile" src={profile} /></Button>
                    </OverlayTrigger>;

  if(!mode && session) {
    history.push("/invalid");
  }

  async function NotifyLogout() {
    if (!session.transactionSucceeded) {
      vipApi
        .fetch("/api/usertracking/cancelflow", "POST", {
          transactionStage: mode === "withdraw" ? "Withdrawal" : "Deposit",
        })
        .then((response) => {
          if (response.ok) {
            invalidateSession();
            history.push("/logout");
          } else {
            if (response.status === 500) {
              console.error(response.statusText);
              history.push({
                pathname: "/error",
              });
            } else if (response.status === 401) {
              console.error(response.statusText);
              history.push({
                pathname: "/expired",
              });
            } else {
              response.json().then((data) => {
                console.error(data);
                onError(data);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          history.push({
            pathname: "/error",
          });
        });
    } else {
      invalidateSession();
      history.push("/logout");
    }
  }

  function onError(response) {
    history.push({
      pathname: '/error',
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message: response.patronErrorMessage ?? "Your Cancel Request Failed. Please Try Again",
        allowRetry: false
      }
    });
  }

  return (
    <div className="header">
      {isMobile && <><Menu firstName={vipAccount?.firstName} lastName={vipAccount?.lastName} />
        <Row>
          <Col xs={3}>{back && backButton}</Col>
          <Col xs={6}>{logo}</Col>          
        </Row>
      </>}
      {!isMobile && <Row>
        <Col>{back && backButton}</Col>
        <Col>{logo}</Col>
        <Col>
          {!isEnrollment && profileButton}
          {!isEnrollment && helpButton}
        </Col>
      </Row>}
    </div>
  );
};

export default Header;